"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareStringsCaseInsensitive = exports.compareStrings = exports.normalizedLowercaseString = exports.normalizedString = void 0;
function normalizedString(str) {
    return str.normalize("NFC");
}
exports.normalizedString = normalizedString;
function normalizedLowercaseString(str, locale) {
    return normalizedString(str.toLocaleLowerCase(locale));
}
exports.normalizedLowercaseString = normalizedLowercaseString;
function compareStrings(locale, str1, str2, options = {}) {
    return str1.localeCompare(str2, locale, options);
}
exports.compareStrings = compareStrings;
function compareStringsCaseInsensitive(locale, str1, str2, options = {}) {
    return compareStrings(locale, normalizedLowercaseString(str1, locale), normalizedLowercaseString(str2, locale), {
        usage: "search",
        ...options,
    });
}
exports.compareStringsCaseInsensitive = compareStringsCaseInsensitive;
//# sourceMappingURL=string_normalization.js.map